<script lang="ts">
    export let tone: 'info' | 'success' | 'warn' = 'info';
    export let icon: string = 'info circle';
    export let title: string = '';
</script>

<div class="auth-callout auth-callout--{tone}" role="status">
    <div class="auth-callout-icon" aria-hidden="true">
        <i class="{icon} icon"></i>
    </div>
    <div class="auth-callout-body">
        {#if title}<p class="auth-callout-title">{title}</p>{/if}
        <slot />
    </div>
</div>

<style>
    .auth-callout {
        display: flex;
        gap: var(--space-3);
        align-items: flex-start;
        padding: var(--space-4);
        border-radius: var(--radius-card);
        border: 1px solid var(--border-color);
        margin-bottom: var(--space-4);
    }

    .auth-callout-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: var(--radius-pill);
    }

    .auth-callout-icon :global(i.icon) {
        font-size: 1.25rem;
        margin: 0;
    }

    .auth-callout--info .auth-callout-icon {
        background: var(--status-info-soft);
        color: var(--status-info-ink);
    }

    .auth-callout--success .auth-callout-icon {
        background: var(--status-success-soft);
        color: var(--status-success-ink);
    }

    .auth-callout--warn .auth-callout-icon {
        background: var(--status-warn-soft);
        color: var(--status-warn-ink);
    }

    .auth-callout-body {
        flex: 1;
        min-width: 0;
    }

    .auth-callout-title {
        margin: 0 0 var(--space-1) 0;
        font-size: var(--text-base);
        font-weight: 500;
        color: var(--grey);
        line-height: 1.4;
    }

    .auth-callout-body :global(p) {
        margin: 0;
        font-size: var(--text-sm);
        color: var(--grey-secondary);
        line-height: 1.5;
    }

    .auth-callout-body :global(p + p) {
        margin-top: var(--space-2);
    }
</style>
